import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export const firebaseApp = initializeApp(CONFIG.firebase);
export const STORAGE = getStorage(firebaseApp);

export const FIRESTORE = getFirestore(firebaseApp);
export const AUTH = getAuth(firebaseApp);
export const FUNCTIONS = getFunctions(firebaseApp);
